<script>
import Drawer from "@/components/drawer.vue";
import Swal from "sweetalert2";

// Custom Component
import PageHeader from "@/components/page-header";
import IDScanForm from "@/components/superAdmin/IDScanDesktopForm/IDScanForm.vue";
import CustomerService from "@/helpers/APIService/customer.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";

export default {
  page: {
    title: "ID Scan",
  },
  data() {
    return {
      title: "ID Scan",
      CustomerData: [],
      isShowIDScanForm: false,
      selectedUser: null,
      isStillLoading: false,
      isEdit: false,
    };
  },
  components: {
    PageHeader,
    Drawer,
    IDScanForm,
  },
  mounted() {
    this.getIdCustomerList();
  },
  methods: {
    // Method is used to get customer list
    getIdCustomerList() {
      this.isStillLoading = true;
      CustomerService.getCustomerList()
        .then((response) => {
          this.CustomerData = response.result;
          this.isStillLoading = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used handle status change
    updateCustomerDetail(data) {
      this.isEdit = true;
      this.selectedUser = data;
      this.isShowIDScanForm = !this.isShowIDScanForm;
    },
    // Method is used to handle  form
    IdScanForm() {
      this.isEdit = false;
      this.selectedUser = null;
      this.isShowIDScanForm = !this.isShowIDScanForm;
    },
    // Method is used to handle customer submission
    handleCustomerSubmit() {
      this.IdScanForm();
      this.getIdCustomerList();
    },
    // Method is used to delete customer
    deleteCustomer(id, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          CustomerService.deleteCustomer(id)
            .then((response) => {
              if (response.status == false) {
                return Middleware.notification(response.message, "warning");
              }
              Middleware.notification("User deleted !!", "success");
              this.CustomerData.splice(index, 1);
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
    // Method is used handle status change
    updateCustomerStatus(id, data) {
      CustomerService.updateCustomer(id, data)
        .then(() => {
          Middleware.notification("Status change successfully !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    copyActivationCode(code) {
      Middleware.copyCode(code);
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :action="IdScanForm"
      text="Add ID Scan"
      :isButton="true"
    />
    <b-card>
      <div class="table-responsive">
        <div class="table table-hover">
          <table class="table table-hover">
            <thead class="table-light">
              <tr>
                <td>Activation Code</td>
                <td>Name</td>
                <td>Email</td>
                <td>Back OCR</td>
                <td>Front OCR</td>
                <td>PMS Type</td>
                <td>SDK Type</td>
                <td>Shortcut</td>
                <td>Expire at</td>
                <td>Status</td>
                <td>Action</td>
              </tr>
            </thead>
            <tbody v-if="isStillLoading">
              <tr v-for="item in 10" :key="item">
                <td class="placeholder-glow" v-for="no in 11" :key="no">
                  <span class="placeholder w-100 placeholder-lg"></span>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="(customer, index) in CustomerData" :key="customer.id">
                <td @click="copyActivationCode(customer.activation_code)">
                  {{
                    customer.activation_code ? customer.activation_code : "-"
                  }}
                </td>
                <td @click="updateCustomerDetail(customer)">
                  {{ customer.name ? customer.name : "-" }}
                </td>
                <td @click="updateCustomerDetail(customer)">
                  {{ customer.email ? customer.email : "-" }}
                </td>
                <td @click="updateCustomerDetail(customer)">
                  {{ customer.total_back_ocr ? customer.total_back_ocr : "-" }}
                </td>
                <td @click="updateCustomerDetail(customer)">
                  {{
                    customer.total_front_ocr ? customer.total_front_ocr : "-"
                  }}
                </td>
                <td @click="updateCustomerDetail(customer)">
                  {{ customer.pms_type ? customer.pms_type : "-" }}
                </td>
                <td @click="updateCustomerDetail(customer)">
                  {{ customer.sdk_type ? customer.sdk_type : "-" }}
                </td>
                <td @click="updateCustomerDetail(customer)">
                  {{
                    customer.write_to_pms_shortcut_key
                      ? customer.write_to_pms_shortcut_key
                      : "-"
                  }}
                </td>
                <td @click="updateCustomerDetail(customer)">
                  {{
                    customer.last_activated_at
                      ? customer.last_activated_at
                      : "-"
                  }}
                </td>
                <td>
                  <div class="form-check form-switch">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="customer.is_active"
                      @change="
                        updateCustomerStatus(customer.id, {
                          is_active: customer.is_active,
                        })
                      "
                    />
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <i
                      v-b-popover.hover="'Edit'"
                      class="fas fa-pencil-alt text-success"
                      @click="updateCustomerDetail(customer)"
                    ></i>
                    <i
                      v-b-popover.hover="'Delete'"
                      class="mdi mdi-trash-can text-danger fs-5 ms-2"
                      @click="deleteCustomer(customer.id, index)"
                    ></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-card>

    <!-- ID Scan Form -->
    <Drawer
      @close="IdScanForm"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="isShowIDScanForm">
        <IDScanForm
          :IdScanDetails="this.selectedUser"
          :isEdit="this.isEdit"
          @cancelSubmit="IdScanForm"
          @submitted="handleCustomerSubmit"
        ></IDScanForm>
      </div>
    </Drawer>
  </div>
</template>
